import { getUsersRequest } from "@common";
import { FetchingState } from "rd-redux-http";
import { createForm, fields, reactBinding } from "rd-redux-forms";

export interface createUserFormFields {
    email: string;
}

export const createUserForm = createForm<createUserFormFields>("CREATE USER FORM", {
    email: fields.string(true)
});

export const createUserFormBindings = reactBinding()
    .default()
    .withForm(createUserForm);

export interface UsersState {
    createUserForm: typeof createUserForm.types.state;
    usersList: typeof getUsersRequest.types.reduxState;
    createUserModalStatus: boolean;
}

export const defaultUsersState: UsersState = {
    createUserForm: createUserForm.state.empty(),
    usersList: { fetchState: FetchingState.INITIAL },
    createUserModalStatus: false
};
